const menuProdutos = {
    label: 'Cadastro de Produtos',
    icon: 'pi pi-fw pi-dollar',
    to: '/vendas/cadastroprodutos',
    rules: ['CHECKOUTS-PAGAMENTOS-01'],
};

export default menuProdutos;
